// import { ViewSupport47Component } from "../../../components/SupportSystem/ViewReports/ViewSupport47Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { OperationReport47Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport47Component";
export function ViewSupport47Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-7)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport47Component />
            <Footer />
        </div>
    );
}
